import apiRequest from "../../helpers/apiRequest";

export async function fetchUsageDashboard() {
  const response = await apiRequest({
    method: "get",
    url: "accounts/admin/usage-dashboard/",
  });
  return response.data;
}

export async function fetchUserPackageHistory(userId) {
  const response = await apiRequest({
    method: "get",
    url: `accounts/admin/usage-dashboard/users/${userId}/history/`,
  });
  return response.data;
}
